import { render } from "./CheckboxComponent.vue?vue&type=template&id=241a69a9"
import script from "./CheckboxComponent.vue?vue&type=script&lang=js"
export * from "./CheckboxComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6684e1c54ce0e601933c41c13e63276/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__